import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ede589e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, " 云盘下载 ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "qh-icon-close" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "page-content" }
const _hoisted_5 = { class: "loading-box" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import { store } from '@remote/store'
import { useBaseStore } from '@remote/store/base'
import { getAuthProvider, startAuthProvider } from '@remote/api/adapter/xos-mqtt'
import { isHeziNative } from '@remote/utils/platform'
import { closeActivity } from '@remote/utils/jsbridge/hezi'
import { isSeparateAccount } from '@remote/api/config'
import { getErrorMessage } from '@remote/utils/base'
import { toast } from '@remote/utils/dialog'
import { uuidv4, logInfo, logError } from '@remote/utils/logger'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function logs (..._args) {
  console.log('[xCloud]', ..._args)
}


const router = useRouter()
// const store = useStore()
const baseStore = useBaseStore()

const currentDeviceId = ref('')
watch(() => {
  return store?.state?.curDeviceRunner?.target
}, (deviceId: string) => {
  logs('[设备连接]:', deviceId)
  if (deviceId && currentDeviceId.value !== deviceId) {
    currentDeviceId.value = deviceId
    checkAuthProvider()
  }
})
onMounted(() => {
  logs('[mounted][wait for ready]')
  baseStore.untilTargetReady().then(() => {
    const deviceId = store?.state?.curDeviceRunner?.target
    if (deviceId && currentDeviceId.value !== deviceId) {
      logs('[device ready]:', deviceId, store)
      currentDeviceId.value = deviceId
      checkAuthProvider()
    }
  })
})

const isError = ref(false)
const countdown = ref(-1)
watch(countdown, () => {
  if (countdown.value > 0) {
    setTimeout(() => {
      countdown.value -= 1
    }, 1000)
  } else if (countdown.value === 0) {
    logs('授权失败，关闭页面')
    onBack()
  }
})

function onBack () {
  if (isHeziNative) {
    closeActivity()
  } else {
    router.back()
  }
}

function checkAuthProvider () {
  const traceId = uuidv4()
  const target = 'xunlei'
  if (!isSeparateAccount) {
    // 旧账号不需要进行授权
    router.replace({
      path: `/cloud/${target}`,
    })
    return
  }
  logInfo('yunpan', {
    traceId,
    category: 'auth_page',
    action: 'check_auth',
    desc: '查询授权情况',
    params: { provider: target },
  })
  getAuthProvider({ provider: target }).then(response => {
    console.log('[getAuthProvider][response]:', response)
    router.replace({
      path: `/cloud/${target}`,
    })
  }).catch(err => {
    console.log('[getAuthProvider][error]:', err)
    console.error(err)
    logInfo('yunpan', {
      traceId,
      category: 'auth_page',
      action: 'start_auth',
      desc: '授权过期，重新发起授权',
      params: { provider: target, code: '' },
    })
    // 重新授权
    startAuthProvider({ provider: target, code: '' }).then(() => {
      logInfo('yunpan', {
        traceId,
        category: 'auth_page',
        action: 'auth_successed',
        desc: '重新授权成功',
        params: { provider: target },
      })
      router.replace({
        path: `/cloud/${target}`,
      })
    }).catch(err => {
      console.error(err)
      isError.value = true
      countdown.value = 5
      const errMsg = getErrorMessage(err)
      toast({ type: 'error', message: errMsg })
      logError('yunpan', {
        traceId,
        category: 'auth_page',
        action: 'auth_failed',
        desc: '重新授权失败',
        params: { provider: target },
        error: err,
        errorText: errMsg,
      })
    })
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["provider_auth", { 'android-padding': _unref(isAndroid), 'ios-padding': _unref(isIOS) }])
  }, [
    _createElementVNode("header", { class: "page-header" }, [
      _hoisted_1,
      _createElementVNode("div", { class: "page-header-left header-left-menus" }, [
        _createElementVNode("span", {
          class: "close",
          onClick: onBack
        }, _hoisted_3)
      ])
    ]),
    _createElementVNode("article", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (!isError.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "正在获取授权信息..."))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "授权失败，即将关闭页面(" + _toDisplayString(countdown.value) + "秒)", 1))
      ])
    ])
  ], 2))
}
}

})